<template>
  <div class="km-profile">
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <!-- ===== HERO ===== -->
      <section class="kp-hero">
        <div class="kp-hero__bg"></div>
        <div class="kp-hero__body">
          <div class="kp-avatar-wrap" @click="doLogin()">
            <img :src="userInfo.header_img || '/img/mine/avatar.png'" class="kp-avatar" alt="avatar"/>
          </div>
          <div class="kp-hero__meta">
            <div class="kp-hero__name">{{ userInfo.username || 'Guest' }}</div>
            <div class="kp-hero__score">
              <span>⭐</span> Credit Score:
              <strong>{{ userInfo.credit_score != null ? userInfo.credit_score : 100 }}</strong>
            </div>
          </div>
        </div>
      </section>

      <!-- ===== WALLET ===== -->
      <section class="kp-section">
        <div class="kp-wallet">
          <div class="kp-wallet__glow"></div>
          <div class="kp-wallet__head">
            <span>💎 Activity Points</span>
            <button class="kp-wallet__refresh" @click="refresh()" aria-label="Refresh">
              <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M3 12a9 9 0 0 1 15.5-6.3L21 8M21 4v4h-4M21 12a9 9 0 0 1-15.5 6.3L3 16M3 20v-4h4"/></svg>
            </button>
          </div>
          <div class="kp-wallet__amount">{{ formatMoney(userInfo.money) }}</div>
          <div class="kp-wallet__actions">
            <button class="kp-wact kp-wact--primary" @click="$router.push('/Deposit')">
              <span>＋</span> Deposit
            </button>
            <button class="kp-wact" @click="openWithdrawPopup()">
              <span>↓</span> Withdraw
            </button>
            <button class="kp-wact" @click="$router.push('/GameRecord')">
              <span>⧉</span> History
            </button>
          </div>
        </div>
      </section>

      <!-- ===== MENU GRID ===== -->
      <section class="kp-section">
        <div class="kp-grid">
          <button class="kp-tile" @click="$router.push('/Infomation')">
            <span class="kp-tile__ico" style="background:linear-gradient(135deg,#ff6b9d,#ff4d8d)">👤</span>
            <span class="kp-tile__lbl">Basic info</span>
          </button>
          <button class="kp-tile" @click="$router.push('/SetLoginPassword')">
            <span class="kp-tile__ico" style="background:linear-gradient(135deg,#60a5fa,#3b82f6)">🔒</span>
            <span class="kp-tile__lbl">Password</span>
          </button>
          <button class="kp-tile" @click="$router.push('/GameRecord')">
            <span class="kp-tile__ico" style="background:linear-gradient(135deg,#fda4af,#f43f5e)">📊</span>
            <span class="kp-tile__lbl">History</span>
          </button>
          <button class="kp-tile" @click="toNotice()">
            <span class="kp-tile__ico" style="background:linear-gradient(135deg,#c084fc,#a020f0)">🔔</span>
            <span class="kp-tile__lbl">Notices</span>
          </button>
          <button class="kp-tile" @click="$router.push('/Support')">
            <span class="kp-tile__ico" style="background:linear-gradient(135deg,#34d399,#10b981)">💬</span>
            <span class="kp-tile__lbl">Support</span>
          </button>
          <button class="kp-tile" @click="$router.push('/Deposit')">
            <span class="kp-tile__ico" style="background:linear-gradient(135deg,#fbbf24,#f59e0b)">💰</span>
            <span class="kp-tile__lbl">Deposit</span>
          </button>
          <button class="kp-tile" @click="$router.push('/Kyc')">
            <span class="kp-tile__ico" style="background:linear-gradient(135deg,#a78bfa,#7c3aed)">🪪</span>
            <span class="kp-tile__lbl">Verify ID</span>
            <span v-if="kycBadge" class="kp-tile__badge" :class="'kp-tile__badge--'+kycBadge.kind">{{ kycBadge.label }}</span>
          </button>
          <button class="kp-tile" @click="$router.push('/Gifts')">
            <span class="kp-tile__ico" style="background:linear-gradient(135deg,#f472b6,#ec4899)">🎁</span>
            <span class="kp-tile__lbl">Gifts</span>
          </button>
        </div>
      </section>

      <!-- ===== LOGOUT ===== -->
      <section class="kp-section kp-section--logout">
        <button class="kp-logout" @click="loginout()">
          <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9"/></svg>
          Sign out
        </button>
        <p class="kp-version">KissMora · v1.0 · Made with 💖</p>
      </section>

      <div class="kp-spacer"></div>
    </van-pull-refresh>

    <!-- ===== WITHDRAW POPUP ===== -->
    <van-popup v-model="showWithdrawPopup" round :close-on-click-overlay="false" class="kp-popup">
      <div class="kp-withdraw">
        <div class="kp-withdraw__head">
          <div class="kp-withdraw__icon">💸</div>
          <div class="kp-withdraw__title">{{ $t("withdraw.crypto_title") }}</div>
          <div class="kp-withdraw__sub">Withdraw your points to an external wallet.</div>
        </div>
        <div class="kp-withdraw__body">
          <label class="kp-field">
            <span>{{ $t('withdraw.wallet_name') }}</span>
            <input v-model="cryptoForm.wallet_name" :placeholder="$t('withdraw.wallet_name_place')"/>
          </label>
          <label class="kp-field">
            <span>{{ $t('withdraw.wallet_address') }}</span>
            <input v-model="cryptoForm.wallet_address" :placeholder="$t('withdraw.wallet_address_place')"/>
          </label>
          <label class="kp-field">
            <span>{{ $t('withdraw.amount') }}</span>
            <input v-model="cryptoForm.amount" type="number" :placeholder="$t('withdraw.amount_place')"/>
          </label>
        </div>
        <div class="kp-withdraw__actions">
          <button class="kp-wbtn kp-wbtn--ghost" @click="closeWithdrawPopup()">{{ $t("setting.cancel") }}</button>
          <button class="kp-wbtn kp-wbtn--primary" @click="submitCryptoWithdraw()" :disabled="cryptoSubmitting">
            {{ $t("withdraw.confirm") }}
          </button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
// Logic preserved from the original Mine page — template + styles simplified.
export default {
  data() {
    return {
      userInfo: {},
      isLoading: false,
      showWithdrawPopup: false,
      cryptoForm: { wallet_name: '', wallet_address: '', amount: '' },
      cryptoSubmitting: false,
      kycStatus: null   // { kyc_status, request_status, has_request }
    };
  },
  computed: {
    kycBadge(){
      const s = this.kycStatus;
      if(!s) return null;
      if(s.kyc_status === 1)    return { kind:'ok',   label:'Verified' };
      if(s.request_status === 0)return { kind:'warn', label:'Pending' };
      if(s.request_status === 2)return { kind:'bad',  label:'Action needed' };
      return { kind:'cta', label:'Start' };
    }
  },
  methods: {
    loadKycStatus(){
      if(!localStorage.getItem('token')) return;
      this.$http({ method:'get', url:'kyc_status' }).then(res => {
        if(res && res.code === 200 && res.data){ this.kycStatus = res.data; }
      });
    },
    formatMoney(v) {
      const n = Number(v);
      if (isNaN(n)) return '0.00';
      return n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    refresh() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
        if (localStorage.getItem('token')) {
          this.getUserInfo();
          this.$toast(this.$t("reservation.refresh"));
        } else {
          this.$router.push({ path: '/Login' });
        }
      }, 400);
    },
    toNotice() {
      if (localStorage.getItem('token')) this.$router.push({ path: '/Notice' });
      else this.$router.push({ path: '/Login' });
    },
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false;
        if (localStorage.getItem('token')) {
          this.getUserInfo();
          this.$toast(this.$t("reservation.refresh"));
        } else {
          this.$router.push({ path: '/Login' });
        }
      }, 500);
    },
    doLogin() {
      if (localStorage.getItem('token')) this.$router.push({ path: '/Infomation' });
      else this.$router.push({ path: '/Login' });
    },
    openWithdrawPopup() {
      if (!localStorage.getItem('token')) { this.$router.push({ path: '/Login' }); return; }
      this.cryptoForm.wallet_name = '';
      this.cryptoForm.wallet_address = '';
      this.cryptoForm.amount = '';
      this.showWithdrawPopup = true;
    },
    closeWithdrawPopup() { this.showWithdrawPopup = false; },
    submitCryptoWithdraw() {
      if (this.cryptoSubmitting) return;
      const name = (this.cryptoForm.wallet_name || '').trim();
      const addr = (this.cryptoForm.wallet_address || '').trim();
      const amt = parseFloat(this.cryptoForm.amount);
      if (!name) { this.$toast.fail(this.$t("withdraw.wallet_name_place")); return; }
      if (!addr) { this.$toast.fail(this.$t("withdraw.wallet_address_place")); return; }
      if (!amt || amt <= 0) { this.$toast.fail(this.$t("setting.correct_money")); return; }
      this.cryptoSubmitting = true;
      this.$http({
        method: 'post', url: 'user_crypto_withdraw',
        data: { wallet_name: name, wallet_address: addr, money: amt }
      }).then(res => {
        this.cryptoSubmitting = false;
        if (res.code === 200) {
          this.$toast.success(res.msg);
          this.showWithdrawPopup = false;
          this.getUserInfo();
          setTimeout(() => this.$router.push({ path: '/GameRecord' }), 900);
        } else {
          this.$toast.fail(res.msg);
        }
      }).catch(() => { this.cryptoSubmitting = false; });
    },
    getUserInfo() {
      this.$http({ method: 'get', url: 'user_info' }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
          if (this.userInfo.status !== 1) {
            this.$toast(this.$t("video.account_out"));
            localStorage.clear();
            this.$router.push({ path: '/Login' });
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    loginout() {
      localStorage.clear();
      this.$router.push({ path: '/Login' });
    }
  },
  created() {
    if (localStorage.getItem('token')) {
      this.getUserInfo();
      this.loadKycStatus();
    } else {
      this.userInfo.username = this.$t("setting.log_reg");
      this.userInfo.ip = this.$t("setting.more_service");
      this.userInfo.header_img = "img/mine/avatar.png";
    }
  }
};
</script>

<style scoped>
.km-profile {
  min-height: 100vh;
  background:
    radial-gradient(800px 400px at -10% 0%, rgba(255,77,141,.08), transparent 60%),
    radial-gradient(700px 400px at 110% 10%, rgba(160,32,240,.08), transparent 60%),
    linear-gradient(180deg, #fdf5f9 0%, #f6eef3 100%);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, "PingFang SC", sans-serif;
  color: #2a1a3f;
  padding-bottom: 140px;
}
.km-profile * { box-sizing: border-box; }
button { font-family: inherit; }

/* ===== HERO ===== */
.kp-hero {
  position: relative; overflow: hidden;
  background: linear-gradient(135deg, #1a1033 0%, #4a1a6e 100%);
  color: #fff;
  padding: 20px 20px 24px;
}
.kp-hero__bg {
  position: absolute; inset: 0;
  background:
    radial-gradient(circle at 15% 20%, rgba(255,77,141,.45), transparent 55%),
    radial-gradient(circle at 90% 80%, rgba(160,32,240,.4), transparent 55%);
  pointer-events: none;
}
.kp-hero__body {
  position: relative; z-index: 1;
  display: flex; align-items: center; gap: 16px;
  max-width: 720px; margin: 0 auto;
}
.kp-avatar-wrap {
  position: relative; display: block; cursor: pointer; flex-shrink: 0;
}
.kp-avatar {
  width: 72px; height: 72px; border-radius: 50%; object-fit: cover;
  border: 3px solid rgba(255,255,255,.4);
  box-shadow: 0 8px 20px rgba(0,0,0,.3);
  background: #eee;
}
.kp-hero__meta { flex: 1; min-width: 0; }
.kp-hero__name {
  font-size: 22px; font-weight: 800; letter-spacing: -.01em;
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
.kp-hero__score {
  font-size: 13px; margin-top: 4px; opacity: .9;
  display: inline-flex; align-items: center; gap: 6px;
}
.kp-hero__score strong { font-weight: 800; color: #ffd3e4; }

/* ===== SECTIONS ===== */
.kp-section {
  max-width: 720px;
  margin: 0 auto;
  padding: 14px 16px 0;
}
.kp-section + .kp-section { padding-top: 14px; }

/* ===== WALLET ===== */
.kp-wallet {
  position: relative; overflow: hidden;
  background: linear-gradient(135deg, #ff4d8d 0%, #a020f0 100%);
  color: #fff;
  border-radius: 18px;
  padding: 18px 20px;
  box-shadow: 0 14px 32px rgba(160,32,240,.28);
}
.kp-wallet__glow {
  position: absolute; top: -40%; right: -20%;
  width: 80%; height: 150%;
  background: radial-gradient(circle, rgba(255,255,255,.3), transparent 60%);
  pointer-events: none;
}
.kp-wallet__head {
  position: relative;
  display: flex; align-items: center; justify-content: space-between;
  font-size: 12px; font-weight: 700; letter-spacing: .05em; text-transform: uppercase;
  opacity: .95;
}
.kp-wallet__refresh {
  background: rgba(255,255,255,.2); border: 1px solid rgba(255,255,255,.25);
  width: 30px; height: 30px; border-radius: 50%; color: #fff; cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  transition: background .2s, transform .25s;
}
.kp-wallet__refresh:hover { background: rgba(255,255,255,.3); transform: rotate(-90deg); }
.kp-wallet__amount {
  position: relative;
  font-size: 32px; font-weight: 800; letter-spacing: -.02em; margin-top: 6px;
  text-shadow: 0 4px 14px rgba(0,0,0,.2);
}
.kp-wallet__actions {
  position: relative;
  display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 8px;
  margin-top: 14px;
}
.kp-wact {
  padding: 10px 8px; border: none; border-radius: 12px;
  background: rgba(255,255,255,.18); color: #fff;
  font-family: inherit; font-weight: 700; font-size: 13px;
  backdrop-filter: blur(8px);
  display: inline-flex; align-items: center; justify-content: center; gap: 6px;
  transition: background .2s, transform .15s;
}
.kp-wact span { font-size: 16px; font-weight: 800; line-height: 1; }
.kp-wact:hover { background: rgba(255,255,255,.28); transform: translateY(-1px); }
.kp-wact--primary { background: #fff; color: #a020f0; box-shadow: 0 8px 18px rgba(0,0,0,.15); }
.kp-wact--primary:hover { background: #fff; box-shadow: 0 12px 24px rgba(0,0,0,.22); }

/* ===== MENU GRID ===== */
.kp-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}
.kp-tile {
  position: relative;
  display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 10px;
  padding: 18px 10px;
  background: linear-gradient(180deg, #fff 0%, #fff6fa 100%);
  border: 1px solid rgba(255,77,141,.12);
  border-radius: 16px;
  box-shadow: 0 4px 14px rgba(255,77,141,.06);
  cursor: pointer;
  transition: transform .15s, box-shadow .2s, border-color .2s;
}
.kp-tile__badge {
  position: absolute; top: 6px; right: 6px;
  font-size: 9px; font-weight: 800; letter-spacing: .04em;
  padding: 2px 7px; border-radius: 999px;
  text-transform: uppercase;
}
.kp-tile__badge--ok   { background: #d1fae5; color: #047857; }
.kp-tile__badge--warn { background: #fef3c7; color: #92400e; }
.kp-tile__badge--bad  { background: #fee2e2; color: #b91c1c; }
.kp-tile__badge--cta  { background: linear-gradient(135deg,#ff4d8d,#a020f0); color:#fff; }
.kp-tile:hover {
  transform: translateY(-3px);
  border-color: rgba(255,77,141,.35);
  box-shadow: 0 12px 24px rgba(255,77,141,.15);
}
.kp-tile:active { transform: translateY(-1px); }
.kp-tile__ico {
  width: 44px; height: 44px; border-radius: 14px;
  display: flex; align-items: center; justify-content: center;
  font-size: 22px; color: #fff;
  box-shadow: 0 6px 14px rgba(26,16,51,.12);
}
.kp-tile__lbl {
  font-size: 13px; font-weight: 700; color: #2a1a3f; letter-spacing: -.01em;
}

/* ===== LOGOUT ===== */
.kp-section--logout { padding-top: 20px; }
.kp-logout {
  width: 100%; padding: 14px;
  display: flex; align-items: center; justify-content: center; gap: 8px;
  background: linear-gradient(180deg, #fff 0%, #fff2f2 100%);
  color: #ef4444; font-weight: 700; font-size: 14px;
  border: 1.5px solid rgba(239,68,68,.25); border-radius: 14px; cursor: pointer;
  box-shadow: 0 4px 12px rgba(239,68,68,.06);
  transition: background .2s, border-color .2s, box-shadow .2s;
}
.kp-logout:hover {
  background: linear-gradient(180deg, #fff2f2 0%, #ffe4e4 100%);
  border-color: #ef4444;
  box-shadow: 0 8px 18px rgba(239,68,68,.15);
}
.kp-version {
  text-align: center; font-size: 11px; color: #b8a9c9; margin: 14px 0 0;
}
.kp-spacer { height: 20px; }

/* ===== WITHDRAW POPUP ===== */
::v-deep .van-popup { border-radius: 20px; }
.kp-popup { overflow: visible; }
.kp-withdraw {
  width: 92vw; max-width: 420px;
  background: #fff; border-radius: 22px; overflow: hidden;
}
.kp-withdraw__head {
  background: linear-gradient(135deg, #1a1033, #4a1a6e);
  padding: 22px 22px 18px; text-align: center; color: #fff;
  position: relative; overflow: hidden;
}
.kp-withdraw__head::before {
  content: ''; position: absolute; inset: 0;
  background: radial-gradient(circle at 50% 0%, rgba(255,77,141,.35), transparent 55%);
}
.kp-withdraw__icon { position: relative; font-size: 32px; margin-bottom: 6px; }
.kp-withdraw__title { position: relative; font-size: 18px; font-weight: 800; letter-spacing: -.01em; }
.kp-withdraw__sub { position: relative; font-size: 12px; opacity: .8; margin-top: 4px; }
.kp-withdraw__body { padding: 18px 20px 6px; display: flex; flex-direction: column; gap: 12px; }
.kp-field { display: flex; flex-direction: column; gap: 6px; }
.kp-field span { font-size: 12px; font-weight: 700; color: #2a1a3f; letter-spacing: .01em; }
.kp-field input {
  padding: 11px 14px; font-family: inherit; font-size: 14px;
  background: #fff9fb; color: #2a1a3f; font-weight: 600;
  border: 1.5px solid rgba(26,16,51,.08); border-radius: 12px; outline: none;
  transition: border-color .2s, background .2s;
}
.kp-field input:focus { border-color: #ff4d8d; background: #fff; }
.kp-field input::placeholder { color: #b8a9c9; font-weight: 500; }
.kp-withdraw__actions { display: flex; gap: 8px; padding: 14px 20px 20px; }
.kp-wbtn {
  flex: 1; padding: 13px; font-family: inherit;
  border-radius: 12px; border: none; cursor: pointer;
  font-size: 14px; font-weight: 700;
  transition: transform .15s, box-shadow .2s, background .2s;
}
.kp-wbtn--ghost {
  background: linear-gradient(135deg, rgba(255,77,141,.08), rgba(160,32,240,.08));
  color: #a020f0; border: 1.5px solid rgba(255,77,141,.3);
}
.kp-wbtn--ghost:hover { background: linear-gradient(135deg, rgba(255,77,141,.15), rgba(160,32,240,.15)); }
.kp-wbtn--primary {
  background: linear-gradient(90deg, #ff4d8d, #a020f0); color: #fff;
  box-shadow: 0 8px 18px rgba(255,77,141,.3);
}
.kp-wbtn--primary:hover { transform: translateY(-1px); box-shadow: 0 12px 24px rgba(255,77,141,.45); }
.kp-wbtn--primary:disabled { opacity: .6; cursor: not-allowed; transform: none; }

/* ===== Responsive ===== */
@media (min-width: 720px) {
  .kp-hero { padding: 28px 24px 32px; }
  .kp-avatar { width: 84px; height: 84px; }
  .kp-hero__name { font-size: 26px; }
  .kp-section { padding-left: 24px; padding-right: 24px; }
  .kp-wallet__amount { font-size: 38px; }
  .kp-grid { gap: 14px; }
  .kp-tile { padding: 22px 12px; }
  .kp-tile__ico { width: 52px; height: 52px; font-size: 26px; }
  .kp-tile__lbl { font-size: 14px; }
  .kp-spacer { height: 40px; }
}

@media (min-width: 960px) {
  .kp-hero { padding: 32px 24px 36px; border-radius: 0; }
  .kp-hero__body { max-width: 880px; }
  .kp-avatar { width: 96px; height: 96px; }
  .kp-hero__name { font-size: 30px; }
  .kp-hero__score { font-size: 14px; }

  .kp-section { max-width: 880px; padding-left: 24px; padding-right: 24px; }
  .kp-wallet { padding: 22px 26px; }
  .kp-wallet__amount { font-size: 42px; }
  .kp-grid { grid-template-columns: repeat(6, 1fr); gap: 16px; }
  .kp-section--logout { max-width: 420px; margin: 28px auto 0; }
}

@media (max-width: 360px) {
  .kp-hero { padding: 16px 14px 18px; }
  .kp-avatar { width: 60px; height: 60px; }
  .kp-hero__name { font-size: 19px; }
  .kp-wallet { padding: 16px 16px; }
  .kp-wallet__amount { font-size: 26px; }
  .kp-grid { grid-template-columns: repeat(3, 1fr); gap: 8px; }
  .kp-tile { padding: 14px 6px; }
  .kp-tile__ico { width: 40px; height: 40px; font-size: 20px; }
  .kp-tile__lbl { font-size: 12px; }
}
</style>
